export const data = [
  { name: "Square", clipPath: "polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)" },
  { name: "Triangle", clipPath: "polygon(50% 0%, 0% 100%, 100% 100%)" },
  {
    name: "Trapezoid",
    clipPath: "polygon(20% 0%, 80% 0%, 100% 100%, 0% 100%)",
  },
  {
    name: "Parallelogram",
    clipPath: "polygon(25% 0%, 100% 0%, 75% 100%, 0% 100%)",
  },
  { name: "Rhombus", clipPath: "polygon(50% 0%, 100% 50%, 50% 100%, 0% 50%)" },
  {
    name: "Pentagon",
    clipPath: "polygon(50% 0%, 100% 38%, 82% 100%, 18% 100%, 0% 38%)",
  },
  {
    name: "Hexagon",
    clipPath: "polygon(25% 0%, 75% 0%, 100% 50%, 75% 100%, 25% 100%, 0% 50%)",
  },
  {
    name: "Heptagon",
    clipPath:
      "polygon(50% 0%, 90% 20%, 100% 60%, 75% 100%, 25% 100%, 0% 60%, 10% 20%)",
  },
  {
    name: "Octagon",
    clipPath:
      "polygon(30% 0%, 70% 0%, 100% 30%, 100% 70%, 70% 100%, 30% 100%, 0% 70%, 0% 30%)",
  },
  {
    name: "Nonagon",
    clipPath:
      "polygon(50% 0%, 83% 12%, 100% 43%, 94% 78%, 68% 100%, 32% 100%, 6% 78%, 0% 43%, 17% 12%)",
  },
  {
    name: "Decagon",
    clipPath:
      "polygon(50% 0%, 80% 10%, 100% 35%, 100% 70%, 80% 90%, 50% 100%, 20% 90%, 0% 70%, 0% 35%, 20% 10%)",
  },
  {
    name: "Bevel",
    clipPath:
      "polygon(20% 0%, 80% 0%, 100% 20%, 100% 80%, 80% 100%, 20% 100%, 0% 80%, 0% 20%)",
  },
  {
    name: "Rabbet",
    clipPath:
      "polygon(0% 15%, 15% 15%, 15% 0%, 85% 0%, 85% 15%, 100% 15%, 100% 85%, 85% 85%, 85% 100%, 15% 100%, 15% 85%, 0% 85%)",
  },
  { name: "Circle", clipPath: "circle(50% at 50% 50%)" },
  { name: "Ellipse", clipPath: "ellipse(25% 40% at 50% 50%)" },
  {
    name: "Right Arrow",
    clipPath:
      "polygon(0 33%, 66% 33%, 66% 0%, 100% 50%, 66% 100%, 66% 67%, 0% 67% )",
  },
  {
    name: "Left Arrow",
    clipPath:
      "polygon(0% 50%, 34% 0%, 34% 33%, 100% 33%, 100% 67%, 34% 67%, 34% 100%)",
  },
  {
    name: "Up Arrow",
    clipPath:
      "polygon(0% 34%, 50% 0%, 100% 34%, 67% 34%, 67% 100%, 33% 100%, 33% 34%)",
  },
  {
    name: "Down Arrow",
    clipPath:
      "polygon(0% 66%, 33% 66%, 33% 0%, 67% 0%, 67% 66%, 100% 66%, 50% 100%)",
  },
  {
    name: "Close",
    clipPath:
      "polygon(20% 0%, 0% 20%, 30% 50%, 0% 80%, 20% 100%, 50% 70%, 80% 100%, 100% 80%, 70% 50%, 100% 20%, 80% 0%, 50% 30%)",
  },
  {
    name: "Star",
    clipPath:
      "polygon(50% 0%, 61% 35%, 98% 35%, 68% 57%, 79% 91%, 50% 70%, 21% 91%, 32% 57%, 2% 35%, 39% 35%)",
  },
  {
    name: "Cross",
    clipPath:
      "polygon(10% 25%, 35% 25%, 35% 0%, 65% 0%, 65% 25%, 90% 25%, 90% 50%, 65% 50%, 65% 100%, 35% 100%, 35% 50%, 10% 50%)",
  },
  {
    name: "Left Point",
    clipPath: "polygon(25% 0%, 100% 0%, 100% 100%, 25% 100%, 0% 50%)",
  },
  {
    name: "Right Point",
    clipPath: "polygon(0% 0%, 75% 0%, 100% 50%, 75% 100%, 0% 100%)",
  },
  {
    name: "Left Chevron",
    clipPath: "polygon(100% 0%, 75% 50%, 100% 100%, 25% 100%, 0% 50%, 25% 0%)",
  },
  {
    name: "Right Chevron",
    clipPath: "polygon(75% 0%, 100% 50%, 75% 100%, 0% 100%, 25% 50%, 0% 0%)",
  },
  { name: "Inset", clipPath: "inset(5% 20% 15% 10%)" },
];
